<!--
 * @Description: 批改作业管理 列表页
 * @Author: PF
 * @Date: 2022-09-23 11:53:25
 * @LastEditors: PF
 * @LastEditTime: 2024-07-24 09:09:54
-->
<template>
  <div>
    <el-dialog class="wp85 hp85" :model-value="openPiGaiList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width: 1030;">
      <template #header>
        <div class="header-left">
          <span class="header-title">{{row.bjmc}}<span v-if="row.zuoyemingc"> - {{ row.zuoyemingc }}</span></span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openPiGaiList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pt0 pr0 pb0">
        <el-container class="hp100">
          <el-main class="pl0 pr0">
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="60" fixed align="center" />
              <el-table-column label="学号" prop="xsxh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="学生" prop="xsxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <!-- 冻结列-Left END -->
              <el-table-column label="课程" prop="kcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="教学单元" prop="jxdybt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="教学内容" prop="jxnrbt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="发布时间" prop="bzsj" width="160" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="提交时间" prop="tjsj" width="160" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="分数" prop="zdf" width="80" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="状态" prop="zt" fixed="right" width="80" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-for="(item, index) in xszyztData.list" :key="index">
                    <span v-if="scope.row.zt === item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="120" fixed="right" align="center">
                <template #default="scope">
                  <el-button v-if="scope.row.zylx === xszylxData.xianShangZuoYe && (scope.row.zt === xszyztData.yiTiJiao || scope.row.zt === xszyztData.yiBuJiao)" link type="success" @click="openXianShangZuoYe=true; tcrow=scope.row">批改</el-button>
                  <el-button v-if="scope.row.zylx === xszylxData.xianXiaZuoYe && (scope.row.zt === xszyztData.yiTiJiao || scope.row.zt === xszyztData.yiBuJiao)" link type="success" @click="openXianXiaZuoYe=true; tcrow=scope.row">批改</el-button>
                  <el-button v-if="scope.row.zylx === xszylxData.xianShangZuoYe && scope.row.zt === xszyztData.yiPiGai" link type="primary" @click="openXianShangZuoYeXiangQing=true;tcrow=scope.row">详情</el-button>
                  <el-button v-if="scope.row.zylx === xszylxData.xianXiaZuoYe && scope.row.zt === xszyztData.yiPiGai" link type="primary" @click="openXianXiaZuoYeXiangQing=true; tcrow=scope.row">详情</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openPiGaiList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xianshangzuoye v-if="openXianShangZuoYe" v-model:openXianShangZuoYe="openXianShangZuoYe" :row="tcrow" @ReturnData="bindTable" />
  <xianshangzuoyexiangqing v-if="openXianShangZuoYeXiangQing" v-model:openXianShangZuoYe="openXianShangZuoYeXiangQing" :row="tcrow" @ReturnData="bindTable" />
  <xianxiazuoye v-if="openXianXiaZuoYe" v-model:openXianXiaZuoYe="openXianXiaZuoYe" :row="tcrow" @ReturnData="bindTable" />
  <xianxiazuoyexiangqing v-if="openXianXiaZuoYeXiangQing" v-model:openXianXiaZuoYe="openXianXiaZuoYeXiangQing" :row="tcrow" @ReturnData="bindTable" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  submitDataGridAction,
  loadSelect,
  closeWindow
} from '@/api/common.js'
import { getZuoYeLeiXing } from '@/utils/meiju'
import pagination from '@/components/pagination.vue'
import xianshangzuoye from './xianshangzuoye.vue'
import xianshangzuoyexiangqing from './xianshangzuoyexiangqing.vue'
import xianxiazuoye from './xianxiazuoye.vue'
import xianxiazuoyexiangqing from './xianxiazuoyexiangqing.vue'

const props = defineProps({
  openPiGaiList: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openPiGaiList', 'ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xsxh', order: 'ascending' }, // ['ascending', 'descending']
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/ziyuanku/xueshengzuoye/weipigaibanjixueshengzuoye',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    dataGrid: dataGrid.value
  })
}

const row = ref()
const xszyztData = ref({ list: [] })
const xszylxData = ref({ list: [] })
watch(
  () => props.openPiGaiList,
  () => {
    if (props.openPiGaiList) {
      row.value = props.row
      dataGrid.value.parms.bjzyid = props.row.id
      loadSelect({
        url: '/api/v2/ziyuanku/xueshengzuoye/xueshengzuoyezhuangtai',
        data: xszyztData
      })
      xszylxData.value = getZuoYeLeiXing()
      bindTable()
    }
  },
  { deep: true, immediate: true }
)

// 弹窗
const tcrow = ref()
const openXianShangZuoYe = ref(false)
const openXianShangZuoYeXiangQing = ref(false)
const openXianXiaZuoYe = ref(false)
const openXianXiaZuoYeXiangQing = ref(false)

// 撤销
const cheXiaoClick = async () => {
  submitDataGridAction({
    url: '/api/v2/ziyuanku/pigai',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要撤销吗?',
    method: 'post',
    callback: function (res) {
      bindTable()
    }
  })
}
</script>
